import { Tag, TagLeftIcon } from "@chakra-ui/react";
import React from "react";

const PrimaryTag = ({ children, icon, ...props }) => (
  <Tag gap={1} variant={"primary"} {...props}>
    {icon && <TagLeftIcon as={icon} boxSize={"15px"} />}
    {children}
  </Tag>
);

export default React.memo(PrimaryTag);
